import React, { useEffect, useState } from "react";
import axios from "axios";
import "./OurOfferedSolutions.css";
import goImg from "./../../../Assets/Images/Go5050.png";
import gotasteImg from "./../../../Assets/Images/Gotaste Logo-13.png";
import pantomimeImg from "./../../../Assets/Images/sproutLogo.png";
import paragonImg from "./../../../Assets/Images/image001.png";
import smImg from "./../../../Assets/Images/SMKW_logo3.png";
import rhtiImg from "./../../../Assets/Images/team2.png";
import rediImg from "./../../../Assets/Images/team3.png";
import silverspooniImg from "./../../../Assets/Images/team4.png";
import nestiImg from "./../../../Assets/Images/team6.png";
import quentediImg from "./../../../Assets/Images/team7.png";
import infiniiImg from "./../../../Assets/Images/logo (1).png";

import Aos from "aos";
import "aos/dist/aos.css";

const OurOfferedSolutions = () => {
 
  
  return (
    
    <div className="container offered">
      <div className="container">
        <div className="offered-fluid text-center">
          <h2 className="text-center my-5">Our Offered Solutions</h2>                    
          <div className="row d-flex justify-content-center">
           
            <div className="col-6 col-md-3  offered-col">
              <a
                className=""
                          
              >
                Enterprise Application
              </a>
            </div>
            <div className="col-6 col-md-3 offered-col">
              <a
                className=""
                          
              >
                ERP
              </a>
            </div>
            <div className="col-6 col-md-3 offered-col">
              <a
                className=""
                          
              >
              Financial Management  
              </a>
            </div>
            <div className="col-6 col-md-3 offered-col">
              <a
                className=""
                          
              >
                Supply Change Management
              </a>
            </div>
            <div className="col-6 col-md-3 offered-col">
              <a
                className=""
                          
              >
                Assets Management
              </a>
            </div>
            <div className="col-6 col-md-3 offered-col">
              <a
                className=""
                          
              >
                Fleet Management
              </a>
            </div>
            <div className="col-6 col-md-3 offered-col">
              <a
                className=""
                          
              >
                HR Software
              </a>
            </div>
            <div className="col-6 col-md-3 offered-col">
              <a
                className=""
                          
              >
                E Learning Software
              </a>
            </div>
            <div className="col-6 col-md-3 offered-col">
              <a
                className=""
                          
              >
                E-Commerce
              </a>
            </div>
            <div className="col-6 col-md-3 offered-col">
              <a
                className=""
                          
              >
                Mobile Apps
              </a>
            </div>
            <div className="col-6 col-md-3 offered-col">
              <a
                className=""
                          
              >
                Document Managment
              </a>
            </div>
            <div className="col-6 col-md-3 offered-col">
              <a
                className=""
                          
              >
                Content Managment
              </a>
            </div>
            <div className="col-6 col-md-3 offered-col">
              <a
                className=""
                          
              >
                CRM
              </a>
            </div>
            <div className="col-6 col-md-3 offered-col">
              <a
                className=""
                          
              >
                Web Portals
              </a>
            </div>
            <div className="col-6 col-md-3 offered-col">
              <a
                className=""
                          
              >
                Marketing & Advertising
              </a>
            </div>
            <div className="col-6 col-md-3 offered-col">
              <a
                className=""
                          
              >
                Data Analytics
              </a>
            </div>
           
         
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurOfferedSolutions;
